/*
	OneVideo 2.0.0 Usage (Webpack)
	Yang @onerockwell
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import Player from '@vimeo/player';

import '../../styles/modules/oneVideo.scss';

// Define the Backbone View here (Optional)
let OneVideoView = Backbone.View.extend({
	
	initialize: function (settings) {
		var self = this;
		self.$videoBoxes = self.$el;
		self.isResponsive = settings.isResponsive || false;
		self.bgVideo = settings.bgVideo || false;
		self.autoplay = settings.autoplay || false;
		
		self.initVideos();
		this.delegateVideoThumbnailClicks()
	},

	events: {

	},
	
	initVideos: function() {
		var self = this;
		
		_.each(self.$videoBoxes, function(box){
			var $box = $(box);
			var boxId = $box.attr('id');
			var type = $box.data('video-type');
			var videoId = $box.data('video-id');
			var videoSrc = $box.data('video-src');
			if(self.bgVideo){
				self.loadHostPlayer(videoId,videoSrc,$box,boxId);
			}else if(type == "vimeo"){
				self.loadVimeoPlayer(videoId,videoSrc,$box,boxId);
			}
		});
	},
	
	loadHostPlayer: function(video_id,video_src,$video_box,video_box_id){
		// Works for vimeo or self-hosted videos
		var self = this, id = '', $videoWrapper = $video_box;
		var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
		var $playerCtl = $videoWrapper.find('.video-ctl');
		let is_inview = false, can_play = false, metadata_loaded = false, has_paused = false;

		var responsive = function(r){
			var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
			if (wrapperRatio >= r) {
				$videoWrapper.find('video').css({
					'width' : '100%',
					'height': $videoWrapper.width()/r
				});
			} else {
				$videoWrapper.find('video').css({
					'height' : '100%',
					'width': $videoWrapper.height()*r
				});
			}
		};
		
		if(self.autoplay){
			var $video = $('<video preload="metadata" loop muted autoplay playsinline><source src="' + video_src + '" type="video/mp4"></video>');
		}else{
			var $video = $('<video preload="metadata" loop muted playsinline><source src="' + video_src + '" type="video/mp4"></video>');
		}
		$playerCtl.text('Play');
		$video_box.prepend($video);
		
		var theVideo = $video[0]; 
		theVideo.muted = true;
		$video.on('loadedmetadata', function() {
			metadata_loaded = true;
			// console.log(`video ${video_id} loaded`);
		})
		$video.on('canplay', function() {
			can_play = true;
			// console.log(`video ${video_id} canplay`);
		})
		console.log("$$video",$video)
		$video.on('play', function() {
			$playerCtl.text('Pause');
			$playerCtl.removeClass('paused').addClass('playing');
			$video.isPlaying = true;
			$video_box.find('video').css({
				'visibility': 'visible',
				'opacity': '1'
			});
			console.log('Video playing!');
		});
		$video.on('pause', function() {
			$playerCtl.text('Play');
			$playerCtl.removeClass('playing').addClass('paused');
			$video.isPlaying = false;
			if(!self.autoplay && self.bgVideo){
				$video_box.find('video').css({
					'visibility': 'hidden',
					'opacity': '0'
				});
			}
			has_paused = true;
			console.log('Video paused!');
		});

		const observer = new window.IntersectionObserver(([entry]) => {
				if (entry.isIntersecting) {
					is_inview = true;
					// console.log('ENTER video elem')
					// console.log(`Can play: ${can_play}, Metadata loaded: ${metadata_loaded}`);
					if (self.autoplay && can_play && metadata_loaded && !$video.isPlaying && !has_paused) {
						theVideo.play();
					}
					return
				}
				is_inview = false;
				// console.log('LEAVE video elem')
			}, {
				root: null,
				threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
			}
		)
		observer.observe(theVideo);

		function toggleVideo(){
			if ($video.isPlaying) {
				theVideo.pause();
			} else {
				theVideo.play();
			}
		}

		$video.on('click', function(){
			//toggleVideo();
		});
		
		if ($playerCtl.length) {
			$playerCtl.text('Pause');
			// $playerCtl.removeClass('paused').addClass('playing');
			$playerCtl.on('click', function(){
				toggleVideo();
			});
		}
		
		$video.on('bufferend', function(){
			console.log("video buffered");
			if (self.isResponsive) {
				responsive(videoRatio);
			}
			console.log('init video');
		});
		
		if (self.isResponsive) {
			$(window).resize(function() {
				clearTimeout(id);
				id = setTimeout(function(){
					responsive(videoRatio);
				}, 400);
			});
		}
	},
	
	loadVimeoPlayer: function(video_id,video_src,$video_box,video_box_id){
		var self = this, id = '', $videoWrapper = $video_box;
		var videoRatio = $videoWrapper.data('ratio') ? $videoWrapper.data('ratio') : 0.6; // 0.6 is default for product video
		var $playerCtl = $videoWrapper.siblings('.video-ctl');
		var responsive = function(r){
			var wrapperRatio = $videoWrapper.width()/$videoWrapper.height();
			// console.log(wrapperRatio + '/' + r);
			if (wrapperRatio >= r) {
				$videoWrapper.find('iframe').css({
					'width' : '100%',
					'height': $videoWrapper.width()/r
				});
			} else {
				$videoWrapper.find('iframe').css({
					'height' : '100%',
					'width': $videoWrapper.height()*r
				});
			}
		};
		
		if (self.isMobile()) {
			var options = {
				// id: video_id,
				byline: false,
				portrait: false,
				title: false,
				loop: false,
				background: true
			};
			var vmplayer = new Player(video_box_id, options);
		} else {
			var $iframe = $('<iframe frameborder="0" src="' + video_src + '?title=0&amp;byline=0&amp;portrait=1&amp;autoplay=1&amp;loop=1&amp;controls=0&amp;background=1">');
			$video_box.html($iframe);
			var vmplayer = new Player($iframe); 
		}
		
		if ($playerCtl.length) {
			
			if (!self.isMobile()) {
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
				$playerCtl.on('click', function(){
					if (vmplayer.isPlaying) {
						vmplayer.pause();
						$playerCtl.text('Play');
						$playerCtl.removeClass('playing').addClass('paused');
					} else {
						vmplayer.play();
						$playerCtl.text('Pause');
						$playerCtl.removeClass('paused').addClass('playing');
					}
				})
			} else {
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
				$playerCtl.on('click', function(){
					if (vmplayer.isPlaying) {
						vmplayer.pause();
					}
					vmplayer.play();
				})
			}
			
		}
		
		vmplayer.setVolume(0);
		vmplayer.on('play', function() {
			vmplayer.isPlaying = true;
			if (self.isMobile()) {
				$video_box.find('iframe').css({
					'opacity' : '1'
				})
				$playerCtl.css({
					'z-index' : '3'
				});
				$playerCtl.text('Pause');
				$playerCtl.removeClass('paused').addClass('playing');
			}
			console.log('played vm video!');
		});
		vmplayer.on('pause', function() {
			vmplayer.isPlaying = false;
			if (self.isMobile()) {
				$video_box.find('iframe').css({
					'opacity' : '0'
				});
				$playerCtl.text('Play');
				$playerCtl.removeClass('playing').addClass('paused');
			}
			console.log('pause vm video!');
		});
		vmplayer.on('loaded', function() {
			if (self.isResponsive) {
				responsive(videoRatio);
			}
			console.log('init vm video');
		});
		
		if (self.isResponsive) {
			$(window).resize(function() {
				clearTimeout(id);
				id = setTimeout(function(){
					responsive(videoRatio);
				}, 400);
			});
		}
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	},

	isMobile: function () {
		if ( ORW.responsive == 'small') {
			return true;
		}
		return false;
	},

	isDesktop: function () {
		if ( ORW.responsive == 'large') {
			return true;
		}
		return false;
	},
	delegateVideoThumbnailClicks: function () {
		const THUMBNAIL_SELECTOR = '.product-media-thumbnails .image-thumbnail';
		const VIDEO_WRAPPER_SELECTOR = '.video-wrapper';
		const VIDEO_CTL_SELECTOR = '.video-ctl';
		const MAIN_VIDEO_SELECTOR = '.product-media-images .video-wrapper video';
	
		function pauseAllThumbnailsVideos() {
			$(`${THUMBNAIL_SELECTOR} video`).each((_, video) => video.pause());
		}
	
		function playAllThumbnailsVideos() {
			$(`${THUMBNAIL_SELECTOR} video`).each((_, video) => video.play());
		}
	
		function resetVideoControls() {
			$('.product-media-thumbnails .video-wrapper .video-ctl').each((_, ctl) => {
				$(ctl).removeClass('playing').addClass('paused');
			});
		}
	
		function handleThumbnailClick() {
			$(document).on('click', THUMBNAIL_SELECTOR, function () {
				// Only reset videos if clicked thumbnail is NOT a video
				if ($(this).find(VIDEO_WRAPPER_SELECTOR).length === 0) {
					$(MAIN_VIDEO_SELECTOR).each((_, video) => video.pause());
					resetVideoControls();
				}
			});
		}
	
		function handleResizeAndLoad() {
			if (window.innerWidth < 1024) {
				pauseAllThumbnailsVideos();
				handleThumbnailClick();
			} else {
				playAllThumbnailsVideos();
			}
		}
	
		function handleVideoWrapperClick() {
			$(document).on('click', `.product-media-thumbnails ${VIDEO_WRAPPER_SELECTOR}`, function (e) {
				e.preventDefault();
	
				const mediaId = $(this).data('media-id');
				const control = $(this).find(VIDEO_CTL_SELECTOR);
	
				if (!mediaId || window.innerWidth > 1024) return;
	
				$(`.product-media-images ${VIDEO_WRAPPER_SELECTOR}[data-media-id="${mediaId}"]`).each((_, wrapper) => {
					if(_ == 1) return
					const video = $(wrapper).find('video')[0];
	
					if (video.paused) {
						video.play();
						control.removeClass('paused').addClass('playing');
					} else {
						video.pause();
						control.removeClass('playing').addClass('paused');
					}
				});

			});
			$(document).on('click', `.product-media-images .video-wrapper .video-ctl`, function (e) {
					const mediaId = $(this).closest('.video-wrapper').data('media-id');
					const control = $(this)
					if(control.hasClass('paused')){
						$(`.product-media-thumbnails ${VIDEO_WRAPPER_SELECTOR}[data-media-id="${mediaId}"] .video-ctl`).each(function(index, item){
							$(item).removeClass('paused').addClass('playing')
						})
					}else{
						$(`.product-media-thumbnails ${VIDEO_WRAPPER_SELECTOR}[data-media-id="${mediaId}"] .video-ctl`).each(function(index, item){
							$(item).removeClass('playing').addClass('paused')
						})
					}

			})

		}
	
		// Initialize on load and resize
		handleResizeAndLoad();
		window.addEventListener('resize', handleResizeAndLoad);
	
		// Handle video wrapper click
		handleVideoWrapperClick();
	}
	
	
});

// Define the module here 
let OneVideo = {
	init: function (settings) {
		return new OneVideoView(settings);
	}
}

// Output the module
export default OneVideo;